import ChevronLeftCircleIcon from '@atlaskit/icon/glyph/chevron-left-circle';
import { AtlassianIcon } from '@atlaskit/logo';
import { colors } from '@atlaskit/theme';
import { inject, observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import Store from '../../store';
import DrawerStore, { Drawer } from '../../store/drawerStore';
import UIStore from '../../store/uiStore';
import Feedback from '../Feedback';
import FastTap from '../mobile/FastTap';
import { onDesktop, onMobile } from '../mobile/responsive';

import NotificationsDrawerButton from './NotificationsDrawerButton';
import SwitcherDrawerButton from './SwitcherDrawerButton';
import UserMenu from './UserMenu';

const Container = styled.div`
  background: white;

  // Vertical nav
  ${onDesktop(`
    width: 64px;
  `)}

  // Horizontal nav
  ${onMobile(`
    position: fixed;
    top: 0;
    left: 0;
    padding: 10px 10px 0;
    width: calc(100vw - 20px);
    height: 36px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 2px solid #EBECF0;
  `)}
`;

const GlobalNavigation = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  line-height: 1;

  > * {
    cursor: pointer;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: ${colors.N40};
      border-radius: 20px;
    }
  }

  // Vertically align icons
  ${onDesktop(`
    flex-direction: column;
    width: 64px;

    > * {
      margin-bottom: 10px;
    }
  `)}

  // Horizontally align icons
  ${onMobile(`
    flex-direction: row;

    > * {
      margin-bottom: 4px;
    }
  `)}
`;

const Bottom = styled.div`
  display: flex;

  ${onDesktop(`
    position: fixed;
    align-items: flex-end;
    bottom: 0;
  `)}
`;

const Top = styled.div`
  ${onDesktop(`
    padding: 40px 16px 0;
    position: fixed;
    top: 0;
  `)}
`;

const Back = styled(FastTap)`
  cursor: pointer;
`;

interface Props {
  drawerStore: DrawerStore;
  uiStore: UIStore;
}

@observer
class Sidebar extends React.Component<Props> {
  render() {
    return (
      <Container data-test-id="sidebar">
        <Top>{this.renderAppIcon()}</Top>
        <Bottom>
          <GlobalNavigation>
            <SwitcherDrawerButton />
            <NotificationsDrawerButton />
            <Feedback />
            <UserMenu />
          </GlobalNavigation>
        </Bottom>
      </Container>
    );
  }

  private closeDrawer = () => this.props.drawerStore.closeDrawer();

  private renderAppIcon = () => {
    const { uiStore, drawerStore } = this.props;

    const shouldShowBackIcon = uiStore.mobileMode && drawerStore.currentDrawer !== Drawer.None;

    return shouldShowBackIcon ? (
      <Back onClick={this.closeDrawer}>
        <ChevronLeftCircleIcon size="large" label="back" />
      </Back>
    ) : (
      <AtlassianIcon />
    );
  };
}

export default inject(({ drawerStore, uiStore }: Store) => ({
  drawerStore,
  uiStore,
}))(Sidebar);
